export default "__VITE_ASSET__a779fdb7__"